export default __webpack_public_path__ + "static/media/EILogo.8da80994.png";